import { Button, Col, Container, Row } from "react-bootstrap";
import Background from "../../image/background5.jpg";

export default function Traditional () {
    return(<>
    <Container fluid style={{background: "url(" + Background + ") no-repeat fixed center"}}>
        <Container>
            <Row className="justify-content-center section">
                <Col md="8"  className="image-over-section">
                    <h2 style={{textAlign:"center"}}>Traditional Knowledge & Values
                    </h2>
                    <p style={{textAlign:"center", fontSize:"1.25em"}}>
                    Universities and books are one way of knowing, being in nature is another. Traditional knowledge is error-proof. It's validated knowledge, since it's extremely experimental and continuously tested against time. Since it is interconnected with environment, the chances that it affects the environment adversely, are extremely low.
                    </p>
                </Col>
            </Row>
            </Container>
            </Container>
            <Container>

            <Row className="justify-content-center section" style={{borderTop:"1px solid #ddd"}}>
                <Col sm="12" md="8">
                    <h3 style={{textAlign:"center"}}>Featured Project: Rural Housing Knowledge Network
                    </h3>
                    
                    <div className="video-container"><iframe width="560" height="315" src="https://www.youtube.com/embed/NkMdcwhzQB0?si=vlnRyiuTQb29NBpa" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                    </div>
                    <p style={{textAlign:"justify"}}>
                    Dr. Chariar helped the Ministry of Rural Development set up the national platform for sharing available information on rural housing solutions and resources.
                    </p>
                    <p style={{textAlign:"justify"}}>Citizens use the platform to seek reliable data on housing materials. Housing sector professionals and administrators use it to identify technologies, seek cost estimates and advice from people and organizations that can help them.
                    </p>
                </Col>
            </Row>

            <Row className="justify-content-center section" style={{borderTop:"1px solid #ddd"}}>
                <Col sm="12" md="10"><h3 style={{marginBottom:"30px"}}>Publications</h3>
                <p>
                <b>ETraditional Technologies and their potential for wealth generation.</b> D. Narasimha Reddy and Vijayaraghavan Chariar. Book of Abstracts, 1st Regional Congress on Traditional Sciences and Technologies of AP, Chirala, AP, June 2 - 4, 1999.
                </p>
                <p>
                <b>Revitalisation of indigenous iron industry.</b> Vijayaraghavan M. Chariar. Recommendations for Rural Technologies-A Report prepared for CAPART Publication of 3rd Congress on Traditional Sciences and Technologies of India, Varanasi, Published by PPST Foundation, p. 54, 2000.
                </p>
                <Button href="./publications#journals">All Publications <i className="bi bi-arrow-right"></i></Button>
                </Col>
            </Row>

            <Row className="justify-content-center section" style={{borderTop:"1px solid #ddd"}}>
                <Col sm="12" md="10"><h3 style={{marginBottom:"30px"}}>Conferences</h3>
                <p>
                <b>National Conference on Traditional Knowledge Systems of India.</b> IIT Kharagpur, India, January 9-11, 2014.
                </p>
                <p>
                <b>Continuing Education Program on Rural Marketing for Rajasthan Khadi Board,</b> IIT Delhi, India, September 17-19, 2014
                </p>
                <Button href="./publications#conferences">All Conferences <i className="bi bi-arrow-right"></i></Button>
                </Col>
            </Row>
        </Container>
        </>
    )
}